import { FormGroup, Label } from 'reactstrap';
import AsyncSelect from 'react-select/async';
import { ErrorMessage } from '@hookform/error-message';
import { FieldErrors, Message, MultipleFieldErrors } from 'react-hook-form';

const FormAsyncSelect = ({
  name,
  label,
  defaultOptions,
  loadOptions,
  isDisabled,
  onChange,
  value,
  placeholder,
  children,
  errors,
  noOptionsEntityLabel,
  errorMessageRenderer = (data: { message: Message; messages?: MultipleFieldErrors }) => (
    <small className="text-danger py-2">{data.message}</small>
  ),
}: {
  name: string;
  label: string;
  defaultOptions?: any[];
  loadOptions: (inputValue: string) => Promise<any[]>;
  isDisabled?: boolean;
  onChange: (value: any) => void;
  value: any;
  placeholder: string;
  children?: React.ReactNode;
  errors?: FieldErrors;
  noOptionsEntityLabel?: string;
  errorMessageRenderer?: (data: { message: Message; messages?: MultipleFieldErrors }) => React.ReactNode;
}) => {
  const getNestedFieldError = (errors: any, fieldPath: string) => {
    return fieldPath.split('.').reduce((obj, key) => {
      return obj?.[key];
    }, errors);
  };
  const fieldError = getNestedFieldError(errors, name);
  return (
    <FormGroup>
      <Label className="form-label text-white" htmlFor={name}>
        {label}
      </Label>
      <AsyncSelect
        inputId={name}
        name={name}
        cacheOptions
        isDisabled={isDisabled}
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length < 2
            ? 'Type at least 2 characters to search'
            : `No ${(noOptionsEntityLabel || label).toLowerCase()} found`
        }
        classNames={{
          //   container: (_state) => 'input-group',
          control: (state) => {
            return `form-control pe-1 shadow-none ${state.menuIsOpen ? 'rounded-bottom-0' : ''}`;
          },
          indicatorSeparator: (_state) => 'd-none',
          dropdownIndicator: (state) => `
          ${state.isFocused ? 'text-primary' : 'text-body-secondary'}`,
          input: (_state) => 'px-0',
          valueContainer: (_state) => 'px-0',
          menu: (_state) => 'my-0 border border-1 shadow-none border-top-0 rounded-bottom-1 rounded-top-0',
          option: (state) => {
            return `${state.isSelected || state.isFocused ? 'text-primary' : 'text-body'} bg-transparent`;
          },
        }}
        styles={{
          input: (base) => ({
            ...base,
            color: 'white',
          }),
        }}
        isClearable
        theme={(theme) => {
          return {
            ...theme,
            colors: {
              ...theme.colors,
              primary: 'var(--vz-primary)', //
              primary25: 'rgba(var(--vz-primary-rgb), 0.25)', //
              primary50: 'rgba(var(--vz-primary-rgb), 0.5)', //
              primary75: 'rgba(var(--vz-primary-rgb), 0.75)', //
              neutral0: 'var(--vz-secondary-bg)',
              neutral5: 'rgba(var(--vz-body-color-rgb), 0.05)',
              neutral10: 'rgba(var(--vz-body-color-rgb), 0.1)',
              neutral20: 'var(--vz-border-color-translucent)', //
              neutral30: 'var(--vz-primary)', //
              //   neutral40: 'var(--vz-secondary-bg)',
              neutral50: 'var(--vz-secondary-color)',
              //   neutral60: 'var(--vz-secondary-bg)',
              //   neutral70: 'var(--vz-secondary-bg)',
              //   neutral80: 'var(--vz-border-color-translucent)',
              // neutral90: 'var(--vz-secondary-bg)',
              //   neutral100: 'var(--vz-body-color)',
            },
          };
        }}
      />

      {fieldError && <ErrorMessage errors={errors} name={name} render={errorMessageRenderer} />}
      {children}
    </FormGroup>
  );
};

export default FormAsyncSelect;
